/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgKebab = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M11.996 7.012a2 2 0 0 0 1.996-2.006A2 2 0 0 0 11.996 3 2 2 0 0 0 10 5.006a2 2 0 0 0 1.996 2.006M11.996 14.012a2 2 0 0 0 1.996-2.006A2 2 0 0 0 11.996 10 2 2 0 0 0 10 12.006a2 2 0 0 0 1.996 2.006M11.996 21.012a2 2 0 0 0 1.996-2.006A2 2 0 0 0 11.996 17 2 2 0 0 0 10 19.006a2 2 0 0 0 1.996 2.006" /></svg>;
export default SvgKebab;